import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterLabel} from "./label.js";

export class FilterSelect extends AbstractFilterComponent {

	static selector = '.js-filter-select';

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.bindEvents();
	}

	bindEvents() {
		let self = this;

		self.node.addEventListener('change', function () {
			self.componentStateChanged();
		});
	}

	isChecked() {
		let self = this;

		return self.node.checked;
	}

	getLabel() {
		let self = this;

		if (self.node.value === '' || self.node.value === 'hide') {
			return;
		}

		let content = self.node.dataset.labelPattern;
		if (! content) {
			return;
		}

		content = content.replace(/{value}/, self.node.value);
		content = content.replace(/{text}/, self.node.options[self.node.selectedIndex].text);

		return new FilterLabel(
			self,
			content
		);
	}

	labelDismissed() {
		let self = this;

		self.filter.setForceUpdateMode();
		self.node.selectedIndex = 0;
		self.node.dispatchEvent(new CustomEvent('change'));
	}

	getFormData() {
		let self = this;

		if (self.node.value === '' || self.node.value === 'hide') {
			return;
		}

		let data = {};
		data[self.node.name] = self.node.value;

		return data;
	}
}
